export const PERMANENT_COOKIE_NAME = 'fingerprint';
export const PERMANENT_COOKIE_EXPIRATION = '01 Aug 9999 00:00:00 UTC';
export const DELETE_COOKIE_EXPIRATION = '01 Aug 1970 00:00:00 UTC';
export const AUTHENTICATION_COOKIE_NAME = 'authentication';
export const LOCALE_COOKIE_NAME = 'flywire-lang';
